import { newlinesToLineBreak } from 'shared-helpers/common';

import type { LocaleMessages } from 'shared-types';

interface Params {
  messages: LocaleMessages;
  value: unknown;
}

const getAttributeValueForEmail = ({ messages, value }: Params) => {
  let parsedValue: string | number = '';
  if (value === null || value === undefined) {
    // do nothing
  } else if (typeof value === 'boolean') {
    parsedValue = value ? messages.commonYes : messages.commonNo;
  } else if (Array.isArray(value)) {
    parsedValue = value.join(', ');
  } else if (typeof value === 'object') {
    parsedValue = Object.keys(value).length ? JSON.stringify(value) : '';
  } else {
    parsedValue = newlinesToLineBreak(`${value}`);
  }

  return parsedValue;
};

export default getAttributeValueForEmail;
